import format from "date-fns/format";

const formatDateTime = (value: Date): string =>
  format(value, "HH:mm MM/dd/yyyy zzz");

export default formatDateTime;
